import { PaginatedDto } from "@core/data/dto/paginated.dto";
import type { Nullable } from "@core/domain/types/nullable.type";
import { Type } from "class-transformer";
import {
    IsArray,
    IsNotEmpty,
    IsNumber,
    IsOptional,
    IsString,
} from "class-validator";

export class ServiceDto {
    @IsNumber()
    @IsNotEmpty()
    id!: number;

    @IsString()
    @IsNotEmpty()
    name!: string;

    @IsNumber()
    @IsNotEmpty()
    entity!: number;

    @IsString()
    @IsOptional()
    catalogue!: Nullable<string>;

    @IsString()
    @IsNotEmpty()
    description!: string;
}

export class ServicesDto extends PaginatedDto {
    @IsArray()
    @Type(() => ServiceDto)
    results!: ServiceDto[];
}
